import Landing from "./Pages/Landing/Landing";

const App = () => {
    return (
            <div>
                <Landing />
            </div>
    );
};

export default App;
